// export const APP_MODE = import.meta.env.MODE; // ["production","development"]
export const ProjectUrl = 'https://api.aakashlife.hkstest.uk';
// export const ProjectUrl = 'https://beta-api.aakashlife.in';
